import { Component } from "react";

class Strategy4OrderbookModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: []
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      this.getOrders();
    }
  }

  getOrders = async () => {
    if (this.props.conditionId) {
      const json = await this.props.getConditionOrders(this.props.conditionId);
      if (json.type === "success") {
        this.setState({ orders: json.orders });
      }
    }
  }

  render() {
    return (
      <div className={this.props.show ? "modal is-active" : "modal"}>
        <div className="modal-background" onClick={this.props.handleClose}></div>

        <div className="modal-card wide-modal">
          <header className="modal-card-head">
            <h5 className="modal-card-title">Orderbook (Condition #{this.props.conditionId})</h5>
            <button className="delete" onClick={this.props.handleClose}></button>
          </header>

          <section className="modal-card-body overflow-auto">
            <div className="columns is-mobile">
              <span className="column is-full py-0">
                <button className="button is-info is-fullwidth" onClick={this.getOrders}>Refresh</button>
              </span>
            </div>

            <hr />

            <table className="table is-hoverable is-striped has-text-centered is-fullwidth is-bordered">
              <thead>
                <tr>
                  <th align="center">Timestamp</th>
                  <th align="center">Instrument</th>
                  <th align="center">Side</th>
                  <th align="center">Quantity</th>
                  <th align="center">Price</th>
                </tr>
              </thead>
              <tbody>
                {this.state.orders.map((order, i) => (
                  <tr key={order.id}>
                    <td>{order.timestamp}</td>
                    <td>{order.instrument}</td>
                    <td>{order.side}</td>
                    <td>{order.qty}</td>
                    <td>{order.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>

          <footer className="modal-card-foot"></footer>
        </div>
      </div>
    );
  }
}

export default Strategy4OrderbookModal;
